import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2)
  },
  summary: {
    backgroundColor: theme.backgroundColor
  }
}))

export {
  useStyles
}